import './styles/input-icon.css'

export default function Tooltip ({children, text}: {children: any, text: string}){
    return (
        <div className="tooltip-container">
            <div className="tooltip-text" style={{whiteSpace: 'nowrap'}}>{text}</div>
            {children}
        </div>
    )
}